import ReactGA from "react-ga4";
import { isLocalhost, isProduction } from "Data/Utils/System";

export default function initGoogleAnalytics() {
	const analyticsId = isProduction ? "G-2B15XCRF42" : "G-X4JJSBXZNB";

	ReactGA.initialize(analyticsId, { testMode: isLocalhost() });
}
